import React from 'react';
import {H6} from '../H6';
import {Section} from '../Section';
import {InfoItem} from './InfoItem';

export const InfoSection = (props: { name: string, phone: string }) => {
    const {name, phone} = props;

    return (
        <Section className="space-y-4 text-13">
            <H6 className="border-b pb-2">주문자 정보</H6>

            <div className="grid grid-cols-2">
                <InfoItem title="이름" content={name}/>
                <InfoItem title="전화번호" content={phone}/>
            </div>
        </Section>
    );
};
